import React, { useEffect, useRef } from 'react';

const NotFoundPage = () => {
  const particlesContainerRef = useRef(null);
  
  useEffect(() => {
    // Create particles
    const particlesContainer = particlesContainerRef.current;
    if (!particlesContainer) return;
    
    // Clear existing particles first
    particlesContainer.innerHTML = '';
    
    // Create new particles
    const particleCount = 15;
    
    for (let i = 0; i < particleCount; i++) {
      const particle = document.createElement('div');
      particle.className = 'absolute w-2 h-2 rounded-full bg-gradient-to-r from-indigo-500 to-purple-500 opacity-0';
      
      // Random position and animation delay
      const delay = Math.random() * 5;
      const xMove = (Math.random() * 200) - 100;
      const leftPos = Math.random() * 100;
      const topPos = 50 + Math.random() * 50;
      
      particle.style.left = `${leftPos}%`;
      particle.style.top = `${topPos}%`;
      particle.style.animationDelay = `${delay}s`;
      
      // Add animation
      particle.style.animation = 'float-up 3s infinite ease-out';
      particle.style.animationDelay = `${delay}s`;
      
      // Add transform for particle movement
      particle.style.transform = 'translateY(0) translateX(0)';
      
      particlesContainer.appendChild(particle);
    }
  }, []);

  return (
    <div className="flex justify-center items-center h-screen bg-gray-50 overflow-hidden">
      <div className="text-center px-8 py-8 max-w-xl">
        {/* Animation container */}
      
        
        {/* 404 title */}
        <h1 className="text-8xl font-bold bg-gradient-to-r from-slate-500 via-gray-500 to-slate-500 bg-clip-text text-transparent inline-block mb-2">404</h1>
        
        {/* Subtitle */}
        <h2 className="text-3xl text-gray-800 mb-6">Page Not Found</h2>
        
        {/* Description */}
        <p className="text-lg text-gray-600 mb-8">
          Oops! The page you're looking for seems to have wandered off. It might have been moved, deleted, or perhaps it never existed at all.
        </p>
        
        {/* Button */}
        <a href="/" className="inline-block px-8 py-3 bg-slate-500 text-white rounded-full text-lg font-medium transition-transform duration-300 ease-in-out hover:scale-105 hover:shadow-lg">
          Return Home
        </a>
      </div>
      
      {/* Custom keyframes for the particles */}
      <style jsx>{`
        @keyframes float-up {
          0% {
            transform: translateY(0) translateX(0);
            opacity: 0;
          }
          10% {
            opacity: 1;
          }
          90% {
            opacity: 0.8;
          }
          100% {
            transform: translateY(-100px) translateX(${(Math.random() * 200) - 100}px);
            opacity: 0;
          }
        }
      `}</style>
    </div>
  );
};

export default NotFoundPage;